<template>
  <v-list-tile class="py-4">
    <v-autocomplete
      v-model="classification"
      clearable
      item-text="treeName"
      item-value="id"
      :items="classifications"
      label="Clasificación"
      :loading="loadingClassifications"
      open-on-clear
      prepend-icon="category"
    />
  </v-list-tile>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { ClassificationDoesNotExists } from "@/store/value-mapping/exceptions.js";

/**
 * A component to select and set the classification in the Value Mapping app.
 */
export default {
  computed: {
    ...mapState("valueMapping", ["classifications", "loadingClassifications"]),
    classification: {
      get() {
        return this.$store.state.valueMapping.classification;
      },
      set(classificationId) {
        this.setClassification(classificationId);
      }
    }
  },
  watch: {
    /**
     * If there is any classification selected set it as route's param.
     */
    classification() {
      this.updateClassificationRoute();
    },
    $route() {
      this.updateClassificationByRoute();
    }
  },
  created() {
    this.getClassifications().then(this.updateClassificationByRoute);
  },
  methods: {
    ...mapActions("valueMapping", [
      "getClassifications",
      "updateClassificationRoute"
    ]),
    ...mapMutations("valueMapping", ["setClassification"]),
    /**
     * Update the classification according to the classificationId in the params of the route.
     * If the classificationId does not exists it will show an error message and redirect to the
     * home view.
     */
    updateClassificationByRoute() {
      const notInRoute = !this.$route.matched.some(function({ name }) {
        return name === "valueMapping/classification";
      });
      if (notInRoute) return;

      const id = Number(this.$route.params.classificationId);

      if (Number.isNaN(id)) {
        this.classificationDoesNotExists(this.$route.params.classificationId);
      }

      if (id && (!this.classification || id !== this.classification.id)) {
        try {
          this.setClassification(id);
        } catch (error) {
          if (error instanceof ClassificationDoesNotExists) {
            this.classificationDoesNotExists(id);
          }
        }
      }
    }
  }
};
</script>
